import * as React from 'react';
import { Main as Main$2 } from './Main.styles.js';

var Main = function Main(_ref) {
  var children = _ref.children,
    type = _ref.type;
  return /*#__PURE__*/React.createElement(Main$2, {
    type: type,
    "data-type": type
  }, children);
};
var Main$1 = Main;

export { Main$1 as default };
//# sourceMappingURL=index.js.map
